export const initGradientBackground = () => {

	const banner = document.querySelector('.banner')

	if (!banner) return

	const canvas = banner.querySelector('#canvas')
	const gl = canvas.getContext('webgl')
	
	if (!gl) alert('WebGL not supported')
	
	let mouseX = 0.5
	let mouseY = 0.5
	let targetMouseX = 0.5
	let targetMouseY = 0.5
	let time = 0
	
	const vertexShaderSource = `
			attribute vec2 a_position;
			varying vec2 v_uv;
			
			void main() {
					v_uv = a_position * 0.5 + 0.5;
					gl_Position = vec4(a_position, 0.0, 1.0);
			}
	`
	
	const fragmentShaderSource = `
			precision mediump float;
			varying vec2 v_uv;
			uniform vec2 u_mouse;
			uniform float u_time;
			uniform vec2 u_resolution;
			
			vec3 color1 = vec3(0.0, 0.0, 0.0);  // #000000
			vec3 color2 = vec3(0.965, 0.298, 0.059);  // #F64C0F
			
			void main() {
					vec2 uv = v_uv;
					vec2 mouse = u_mouse;
					
					// Create multiple gradient influences (flipped: black at top, orange at bottom)
					float gradient1 = smoothstep(0.0, 1.0, 1.0 - uv.y);
					
					// Mouse-influenced radial gradient (reduced strength)
					float dist = distance(uv, mouse);
					float radialGradient = (1.0 - smoothstep(0.0, 0.8, dist)) * 0.4;
					
					// Animated wave distortion (reduced)
					float wave = sin(uv.x * 3.14159 * 4.0 + u_time * 2.0) * 0.05;
					float wave2 = cos(uv.y * 3.14159 * 2.0 + u_time * 1.5) * 0.05;
					
					// Mouse-influenced directional gradient (reduced) - with safety check
					vec2 mouseDir = mouse - vec2(0.5, 0.5);
					float mouseInfluence = 0.0;
					if (length(mouseDir) > 0.01) {
							mouseDir = normalize(mouseDir);
							mouseInfluence = (dot(uv - vec2(0.5, 0.5), mouseDir) * 0.3 + 0.5) * 0.3;
					}
					
					// Combine all influences (favor the original gradient more)
					float finalGradient = mix(
							gradient1 + wave + wave2,
							radialGradient + mouseInfluence,
							0.3
					);
					
					// Add some noise for texture
					float noise = fract(sin(dot(uv, vec2(12.9898, 78.233))) * 43758.5453);
					finalGradient += (noise - 0.5) * 0.01;
					
					// Smooth the gradient with more black bias
					finalGradient = smoothstep(0.2, 0.9, finalGradient);
					
					// Mix the colors
					vec3 finalColor = mix(color1, color2, finalGradient);
					
					// Reduce color shifting
					finalColor.r += mouse.x * 0.03;
					finalColor.g += mouse.y * 0.02;
					
					gl_FragColor = vec4(finalColor, 1.0);
			}
	`
	
	function createShader(gl, type, source) {
		const shader = gl.createShader(type)
		gl.shaderSource(shader, source)
		gl.compileShader(shader)
	
		if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
			console.error('Shader compile error:', gl.getShaderInfoLog(shader))
			gl.deleteShader(shader)
			return null
		}
	
		return shader
	}
	
	function createProgram(gl, vertexShader, fragmentShader) {
		const program = gl.createProgram()
		gl.attachShader(program, vertexShader)
		gl.attachShader(program, fragmentShader)
		gl.linkProgram(program)
	
		if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
			console.error('Program link error:', gl.getProgramInfoLog(program))
			gl.deleteProgram(program)
			return null
		}
	
		return program
	}
	
	const vertexShader = createShader(gl, gl.VERTEX_SHADER, vertexShaderSource)
	const fragmentShader = createShader(
		gl,
		gl.FRAGMENT_SHADER,
		fragmentShaderSource
	)
	const program = createProgram(gl, vertexShader, fragmentShader)
	
	const positions = new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1])
	
	const positionBuffer = gl.createBuffer()
	gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer)
	gl.bufferData(gl.ARRAY_BUFFER, positions, gl.STATIC_DRAW)
	
	const positionAttributeLocation = gl.getAttribLocation(program, 'a_position')
	const mouseUniformLocation = gl.getUniformLocation(program, 'u_mouse')
	const timeUniformLocation = gl.getUniformLocation(program, 'u_time')
	const resolutionUniformLocation = gl.getUniformLocation(program, 'u_resolution')
	
	function resizeCanvas() {
		canvas.width = window.innerWidth
		canvas.height = window.innerHeight
		gl.viewport(0, 0, canvas.width, canvas.height)
	}
	
	function render() {
		time += 0.016
	
		mouseX += (targetMouseX - mouseX) * 0.08
		mouseY += (targetMouseY - mouseY) * 0.08
	
		gl.clearColor(0, 0, 0, 1)
		gl.clear(gl.COLOR_BUFFER_BIT)
	
		gl.useProgram(program)
	
		gl.enableVertexAttribArray(positionAttributeLocation)
		gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer)
		gl.vertexAttribPointer(positionAttributeLocation, 2, gl.FLOAT, false, 0, 0)
	
		gl.uniform2f(mouseUniformLocation, mouseX, mouseY)
		gl.uniform1f(timeUniformLocation, time)
		gl.uniform2f(resolutionUniformLocation, canvas.width, canvas.height)
	
		gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4)
	
		requestAnimationFrame(render)
	}
	
	document.addEventListener('mousemove', (e) => {
		targetMouseX = e.clientX / window.innerWidth
		targetMouseY = 1.0 - e.clientY / window.innerHeight
	})

	// Initialize mouse position immediately when the script runs
	targetMouseX = 0.5
	targetMouseY = 0.5
	mouseX = targetMouseX
	mouseY = targetMouseY

	document.addEventListener('DOMContentLoaded', () => {
		// Set initial mouse position to center of screen
		targetMouseX = 0.5
		targetMouseY = 0.5
	})
	
	window.addEventListener('resize', resizeCanvas)
	
	resizeCanvas()
	render()
}

export default () => {}